import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './Hero';
import './HomePage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { portfolioProjects, publicSrc } from '../data/portfolioProjects';

const homePortfolioPreview = portfolioProjects.slice(0, 3);

const HomePage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out'
    });
  }, []);

  return (
    <div className="home-page">
      <Hero />
      
      {/* About Us Teaser */}
      <section className="about-teaser" data-aos="fade-up">
        <div className="section-underline-animated"></div>
        <div className="container">
          <h2 data-aos="fade-up" data-aos-delay="100">Advanced Metal Shop Ltd.</h2>
          <p data-aos="fade-up" data-aos-delay="200">With over 20 years of experience in precision metal fabrication, we combine traditional craftsmanship with cutting-edge technology to deliver exceptional results for every project.</p>
          <Link to="/about" className="learn-more-btn" data-aos="fade-up" data-aos-delay="300">Learn More</Link>
        </div>
      </section>

      {/* Services Teaser */}
      <section className="services-teaser" data-aos="fade-up">
        <div className="section-underline-animated"></div>
        <div className="container">
          <h2 className="services-title" data-aos="fade-up" data-aos-delay="100" style={{ textAlign: 'center', fontWeight: 700, fontSize: '2.5rem', marginBottom: '0.5rem' }}>Our Services</h2>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2.5rem' }}>
            <div style={{ width: '80px', height: '4px', background: 'linear-gradient(90deg, #b7410e 0%, #ff6b3d 100%)', borderRadius: '2px', animation: 'glow-line 3s ease infinite' }}></div>
          </div>
          <div className="services-grid">
            <div className="service-card" data-aos="fade-up" data-aos-delay="200">
              <h3>Miscellaneous Metals</h3>
              <p>Stair systems, railings, guards, fencing, brackets, and one-off site metal, fabricated to your engineered drawings and approved details for commercial and industrial work.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
            <div className="service-card" data-aos="fade-up" data-aos-delay="250">
              <h3>Structural</h3>
              <p>Primary structural steel—beams, columns, frames, and connections, shop-fabricated to your engineered drawings and project specifications.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
            <div className="service-card" data-aos="fade-up" data-aos-delay="300">
              <h3>Installation</h3>
              <p>On-site erection and install to your engineered drawings, anchor plans, and site schedule, with crane access and safety coordinated with your team.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
            <div className="service-card" data-aos="fade-up" data-aos-delay="400">
              <h3>Architectural Metals</h3>
              <p>Feature screens, canopies, entrance metal, façade accents, and custom assemblies built to your engineered and architectural drawing sets and finish schedules.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
            <div className="service-card" data-aos="fade-up" data-aos-delay="500">
              <h3>Metal Fabrication</h3>
              <p>Custom metal fabrication to your engineered drawings, from takeoff and detailing through shop completion.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
            <div className="service-card" data-aos="fade-up" data-aos-delay="600">
              <h3>Welding</h3>
              <p>Professional welding to your engineered drawings, WPS, and project weld requirements using advanced processes and in-house equipment.</p>
              <Link to="/services" className="view-services-btn">View All Services</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-teaser" data-aos="fade-up">
        <div className="section-underline-animated"></div>
        <div className="container">
          <h2 data-aos="fade-up" data-aos-delay="50">Our work</h2>
          <div className="portfolio-grid">
            {homePortfolioPreview.map((project, i) => (
              <Link
                key={project.id}
                to={`/projects/${project.id}`}
                className="portfolio-item"
                data-aos="fade-up"
                data-aos-delay={70 + i * 45}
              >
                <img src={publicSrc(project.mainImage)} alt="" />
                <div className="portfolio-overlay">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </Link>
            ))}
          </div>
          <Link to="/portfolio" className="see-work-btn" data-aos="fade-up" data-aos-delay="220">
            See our work
          </Link>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="contact-cta" data-aos="fade-up">
        <div className="section-underline-animated"></div>
        <div className="container">
          <h2 data-aos="fade-up" data-aos-delay="100">Ready to Start Your Project?</h2>
          <p data-aos="fade-up" data-aos-delay="200">Let's discuss how we can bring your vision to life</p>
          <Link to="/contact" className="quote-btn" data-aos="fade-up" data-aos-delay="300">Get a Quote</Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage; 